import { LoadingButton } from '@mui/lab'
import { Box, Button, Card, CardActions, CardContent, CardHeader, Divider, Grid, TextField, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { runJoiValidate } from 'src/_utils'
import { SALLA_INTEGRATION_SCHEMA } from '../ValidationSchemas'

export default function SallaIntegrationCard({
    data,
    loading,
    isSuccess,
    error,
    onConfirm
}) {
    const { t } = useTranslation()

    const [salla, setSalla] = useState({
        client_id: "",
        client_secret: "",
        app_id: ""
    })

    const onChangeHandler = ({ target: { name, value } }) => {
        setSalla((prevState) => ({
            ...prevState,
            [name]: value
        }))
    }

    useEffect(() => {
        if (!!data) {
            setSalla({ ...data })
        }
    }, [data])

    const [validationErrors, setValidationErrors] = useState(null)

    const onConfirmHandler = () => {
        try {
            setValidationErrors(null)
            const errors = runJoiValidate(SALLA_INTEGRATION_SCHEMA, salla)
            if (errors) {
                setValidationErrors(errors)
                return
            }
            onConfirm({ salla })
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={t("Integrate with your Salla account")} />
            <Divider />
            <CardContent sx={{ flex: 1 }}  >
                <TextField
                    name="app_id"
                    label={t("App ID")}
                    value={salla.app_id ?? ''}
                    onChange={onChangeHandler}
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin='dense'
                    error={!!validationErrors?.app_id}
                    helperText={validationErrors?.app_id ?? ''}
                />
                <TextField
                    name="client_id"
                    label={t("Client ID")}
                    value={salla.client_id ?? ''}
                    onChange={onChangeHandler}
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin='dense'
                    error={!!validationErrors?.client_id}
                    helperText={validationErrors?.client_id ?? ''}
                />
                <TextField
                    name="client_secret"
                    label={t("Client Secret")}
                    value={salla.client_secret ?? ''}
                    onChange={onChangeHandler}
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin='dense'
                    error={!!validationErrors?.client_secret}
                    helperText={validationErrors?.client_secret ?? ''}
                />
            </CardContent>
            <Divider />
            <CardActions>
                {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                {error && <Typography color="error">{error}</Typography>}
                <Box mr="auto" />
                <LoadingButton
                    color="primary"
                    variant="contained"
                    onClick={onConfirmHandler}
                    loading={loading}
                    sx={{ textTransform: "none" }}
                >
                    {t("Confirm")}
                </LoadingButton>
            </CardActions>
        </Card>
    )
}
